import { render } from "./UpgradeView.vue?vue&type=template&id=0b27d6ee"
import script from "./UpgradeView.vue?vue&type=script&lang=js"
export * from "./UpgradeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__